<template>
  <div class="headerBox">
    <div class="header">
      <div class="headerCom df just-between align-center">
        <router-link to="/home">
          <img src="@/assets/images/logo.png" alt="" class="header-logo" />
        </router-link>
        <div v-if="!$isMobile" class="rightBox df align-center">
          <div class="menuList" ref="menuList">
            <el-menu
              mode="horizontal"
              menu-trigger="hover"
              :unique-opened="true"
            >
              <!-- :class="[activeIndex == item.index ? 'show-border' : '']" -->
              <el-submenu
                v-for="(item, index) in menuList"
                :key="index"
                :index="item.index"
              >
                <template slot="title">
                  <span>{{ item.name }}</span>
                  <i class="el-icon-arrow-down menu-arrow"></i>
                  <!-- <i v-if="activeIndex == item.index" class="el-icon-arrow-down menu-arrow"></i> -->
                </template>
                <div class="subMenu df just-between">
                  <div class="left-cloumn">
                    <div class="sub-content df">
                      <el-menu-item
                        class="sub-menu-item"
                        v-for="(subItem, subIns) in item.subList"
                        :key="subIns"
                        :index="subItem.index"
                      >
                        <i class="arrow-right"></i>
                        <router-link :to="subItem.link">{{
                          subItem.name
                        }}</router-link>
                      </el-menu-item>
                    </div>
                  </div>
                  <div class="right-column">
                    <img
                      src="@/assets/images/menuLogo.png"
                      alt=""
                      class="menuLogo"
                    />
                  </div>
                </div>
              </el-submenu>
            </el-menu>
          </div>
          <div class="search">
            <!--  suffix-icon="el-icon-search" -->
            <el-input class="search-input" v-model.trim="searchValue">
              <template slot="suffix">
                <i class="el-icon-search" @click="handleSearch"></i>
              </template>
            </el-input>
          </div>
        </div>
        <div v-else class="rightBox">
          <img
            ref="headerLogo"
            src="@/assets/images/menu.png"
            alt=""
            class="header-logo"
            @click="() => (drawer = !drawer)"
          />
        </div>
      </div>
      <div v-if="drawer" class="menuList" ref="menuList" @wheel="preventScroll" @touchmove="preventScroll">
        <div class="search">
          <el-input class="search-input" v-model.trim="searchValue">
            <template slot="suffix">
              <i class="el-icon-search" @click="handleSearch"></i>
            </template>
          </el-input>
        </div>
        <el-menu mode="vertical" menu-trigger="hover" :unique-opened="true">
          <el-submenu
            v-for="(item, index) in menuList"
            :key="index"
            :index="item.index"
          >
            <template slot="title">
              <span>{{ item.name }}</span>
              <!-- <i class="el-icon-arrow-down menu-arrow"></i> -->
            </template>
            <div class="subMenu">
              <div class="left-cloumn">
                <div class="sub-content df">
                  <el-menu-item
                    class="sub-menu-item"
                    v-for="(subItem, subIns) in item.subList"
                    :key="subIns"
                    :index="subItem.index"
                    @click="() => drawer = false"
                  >
                    <i class="arrow-right"></i>
                    <router-link :to="subItem.link">{{
                      subItem.name
                    }}</router-link>
                  </el-menu-item>
                </div>
              </div>
            </div>
          </el-submenu>
        </el-menu>
      </div>
    </div>
  </div>
</template>

<script>
import { menuList } from "@/data/index";
export default {
  name: "Header",
  data() {
    return {
      menuList,
      searchValue: "",
      drawer: false,
      // activeIndex: '',
    };
  },
  mounted() {
    if(this.$isMobile) {
      document.addEventListener('click', this.handleClickOutside);
    }
  },
  beforeUnmount() {
    document.removeEventListener('click', this.handleClickOutside);
  },
  methods: {
    // handleSelect(key, keyPath) {
    //   this.activeIndex = key;

    // },
    // handleClose() {
    //   this.activeIndex = '';
    // },

    handleClickOutside(event) {
      const targetDiv = this.$refs.menuList;
      const logo = this.$refs.headerLogo;
      if (targetDiv && !logo.contains(event.target) && !targetDiv.contains(event.target)) {
        this.drawer = false
        // const el = document.getElementsByClassName('menuList');
        // el[0].style.display = 'none';
      }
    },
    preventScroll(event) {
      event.preventDefault();
      event.stopPropagation();
      return false;
    },
    // 全局搜索
    handleSearch() {
      // if (this.searchValue) {
        if(this.drawer) this.drawer = false;
        this.$router.push({
          name: "Results",
          query: {
            searchValue: this.searchValue,
          },
        });
        // this.searchValue = ""
      // } else {
      //   this.$message.error("请输入搜索内容");
      // }
    },
  },
};
</script>

<style lang="scss" scoped>
@use "../../styles/index.scss";
$menu-hight: 100px;

.headerBox {
  height: $menu-hight;
}

.header {
  position: fixed;
  top: 0;
  z-index: 99;
  background: #fff;
  box-shadow: 0px 2px 5px 0px rgba(0, 0, 0, 0.05);
}

.headerCom {
  width: 1220px;
  height: $menu-hight;
  margin: 0 auto;
  // display: flex;
  // justify-content: space-between;
  // align-items: center;

  .header-logo {
    height: 52px;
    cursor: pointer;
  }

  // .rightBox {
  //   display: flex;
  //   align-items: center;
  // }
}
.menuList {
  min-width: 554px;

  ::v-deep .el-menu {
    // .show-border {
    //   .el-submenu__title {
    //     border-bottom: 3px solid #C30D23 !important;
    //   }
    // }

    .el-submenu__title {
      position: relative;
      font-size: 18px;
      margin-right: 58px;
      height: $menu-hight;
      line-height: $menu-hight;
      border-bottom: none;
      @media screen and (max-width: 768px) {
        height: 48px;
        line-height: 48px;
      }

      .el-submenu__icon-arrow {
        display: none;
      }

      .menu-arrow {
        display: none;
        position: absolute;
        right: 27%;
        top: 75%;
        font-size: 18px;
        color: #c30d23;
        font-weight: 700;
      }
    }
    .is-opened {
      .el-submenu__title {
        border-bottom: 3px solid #c30d23 !important;
      }
      .menu-arrow {
        display: block;
      }
    }
  }

  .el-menu,
  .el-submenu {
    height: $menu-hight;
    @media screen and (max-width: 768px) {
      height: 100%;
    }
  }
}
.headerCom .menuList ::v-deep .el-menu .el-submenu__title {
  border-bottom: none;
}

.search {
  width: 240px;

  ::v-deep .search-input {
    .el-input__inner {
      background: #f7f7f7;
      border-radius: 18px;
      border: none;
    }
    .el-icon-search {
      color: #156aa3;
      font-weight: 700;
      line-height: 40px;
      margin-right: 5px;
      cursor: pointer;
    }
  }
}

.subMenu {
  width: 1220px;
  margin: 0 auto;
  // display: flex;
  gap: 90px;
  padding: 19px 0;

  .el-menu-item {
    width: 50%;
    margin-bottom: 34px;
    color: #333 !important;
  }

  .el-menu-item:last-child {
    margin-bottom: 0;
  }

  .left-cloumn {
    .sub-content {
      width: 500px;
      text-align: left;
      margin-left: 46px;
      // width: 373px;
      // text-align: center;
      flex-wrap: wrap;
      border-right: none;
    }

    .arrow-right {
      border: dotted #156aa3;
      border-width: 0 2px 2px 0;
      display: inline-block;
      padding: 3px;
      transform: rotate(-45deg);
      -webkit-transform: rotate(-45deg);
      margin-right: 10px;
    }
  }

  .right-column {
    width: 320px;
    margin-right: 50px;
  }

  .menuLogo {
    width: 320px;
    height: 180px;
  }
}

@media screen and (max-width: 768px) {
  .headerBox {
    height: 72px;
    .headerCom {
      width: calc(100% - 12px - 12px);
      height: 72px;
      .header-logo {
        height: 32px;
      }
    }
  }
  .menuList {
    background: #fff;
    min-width: 100%;
    padding: 12px 24px;
    .search {
      width: 100%;
      margin-bottom: 12px;
    }
    ::v-deep .el-menu {
      border-right: none;
      .el-submenu__title {
        font-size: 12px;
        // .menu-arrow {
        //   font-size: 12px;
        // }
      }
      .is-opened {
        .el-submenu__title {
          border-bottom: none !important;
        }
      }
      .el-menu-item:focus,
      .el-menu-item:hover,
      .el-submenu__title:hover {
        background: transparent;
      }
      .el-menu-item {
        padding: 0;
        min-width: auto;
        font-size: 12px;
      }
      .el-submenu:last-child {
        .sub-content {
          display: block;
        }
      }
    }
  }
  .subMenu {
    width: 100%;
    padding: 0;
    .el-menu-item {
      margin-bottom: 0;
    }
    .left-cloumn {
      .sub-content {
        width: 100%;
        margin-left: 0;
      }
    }
  }
}
</style>
